import { useState } from "react";
import type { EnvironmentId } from "@cmmd-forge/contracts";
import { downloadEnvironmentAttachment } from "~/lib/downloadEnvironmentAttachment";

export function useAttachmentDownload(input: {
  readonly environmentId: EnvironmentId;
  readonly attachmentId: string;
  readonly filename: string;
}) {
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);
  const download = () => {
    setError(null);
    setPending(true);
    void downloadEnvironmentAttachment(input)
      .catch((cause: unknown) => {
        const message = cause instanceof Error ? cause.message : "Attachment download failed.";
        setError(`Could not download ${input.filename}. ${message}`);
      })
      .finally(() => setPending(false));
  };
  return { download, error, pending };
}
